import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a64d576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-keyword" }
const _hoisted_2 = { class: "add-keyword-filter" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Add ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_input = _resolveComponent("select-input")!
  const _component_language_selector = _resolveComponent("language-selector")!
  const _component_autocomplete = _resolveComponent("autocomplete")!
  const _component_editable_content_input = _resolveComponent("editable-content-input")!
  const _component_default_button = _resolveComponent("default-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_select_input, {
        class: "keyword-category-select",
        value: _ctx.localSelectItems.keywordCategory,
        options: _ctx.keywordCategories,
        "item-label": "name",
        "item-key": "id",
        placeholder: "Select Keyword type",
        onOnSelect: _cache[0] || (_cache[0] = (data) => _ctx.setData({ keywordCategory: data }))
      }, null, 8, ["value", "options"]),
      _createVNode(_component_language_selector, {
        disabled: _ctx.isDisabledLanguageAndGroups,
        value: _ctx.localSelectItems.language,
        "no-placeholder": "",
        onUpdate: _cache[1] || (_cache[1] = (data) => _ctx.setData({ language: data }))
      }, null, 8, ["disabled", "value"])
    ]),
    _createVNode(_component_autocomplete, {
      value: _ctx.localSelectItems.group.name,
      options: _ctx.searchGroups,
      disabled: _ctx.isDisabledLanguageAndGroups,
      onSearch: _ctx.searchAdGroup,
      onSelect: _cache[2] || (_cache[2] = (data) => _ctx.setData({ group: data || {} }))
    }, null, 8, ["value", "options", "disabled", "onSearch"]),
    _createVNode(_component_editable_content_input, {
      class: "space",
      value: _ctx.localSelectItems.keywords,
      placeholder: "Add new keywords (line separated)",
      onReturned: _cache[3] || (_cache[3] = (data) => _ctx.setData({ keywords: data }))
    }, null, 8, ["value"]),
    _createVNode(_component_default_button, {
      class: "space",
      onClick: _ctx.submit
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}